import React from 'react';
// components
import StatusList from 'src/components/status-list-component/status-list-component';
import BagTagComponent from 'src/components/bag-tags/bag-tags.component';
import FlightMapComponent from 'src/components/flight-map/flight-map.component';
import DriverMapComponent from 'src/components/driver-map/driver-map.component';
// styles
const styles = require('./complete-status.scss');
// product service
import BookingRef from '../../services/booking-ref';
import BookingProductService from '../../services/booking-product.service';
import { placeholderReplace } from 'src/services/string-helper';
// enums
import { BagsJourneyStatus, BagsJourneyType } from 'src/globals';

declare var exponea: any;

interface IState {
  loaded: boolean;
  checkedBags: Array<any>;
  repatBags: Array<any>;
}

interface IProps {
  trackingData: any;
  language: string;
  multiLang: any;
}

class CompleteStatusComponent extends React.Component<IProps, IState> {
  private product = null;
  public bookingProductService = null;

  constructor(props: any) {
    super(props);
    this.state = {
      loaded: false,
      checkedBags: [],
      repatBags: [],
    };
  }

  componentDidMount() {
    const {
      completedTrackingStatus,
      trackingBookingDetails,
      collectionSlot,
    } = this.props.trackingData;
    const { completedPassengerLuggageData } = completedTrackingStatus;

    this.bookingProductService = new BookingProductService(
      trackingBookingDetails,
      collectionSlot
    );
    this.product = this.bookingProductService.returnProductDetails();
    this.setState({ loaded: true });

    if (completedPassengerLuggageData !== null) {
      const checkedBags = completedPassengerLuggageData.filter(
        (item) => item.iataCode !== ''
      );
      const repatBags = completedPassengerLuggageData.filter(
        (item) => item.iataCode === ''
      );

      this.setState({ checkedBags: checkedBags });
      this.setState({ repatBags: repatBags });
    }

    exponea.track('tracking_screen', {
      page_name: 'Completed',
      product_type: 'abc',
    });
  }

  public render() {
    const logoClass = (code) => {

      switch (code) {
        case 'AA': {
          return styles.logoAirlineAA;
        }
        case 'AY': {
          return styles.logoAirlineAY;
        }
        case 'BA': {
          return styles.logoAirlineBA;
        }
        case 'CX': {
          return styles.logoAirlineCX;
        }
        case 'EZY': {
          return styles.logoAirlineU2;
        }
        case 'QF': {
          return styles.logoAirlineQF;
        }
        case 'U2': {
          return styles.logoAirlineU2;
        }
        case 'EZY': {
          return styles.logoAirlineU2;
        }
        case 'VS': {
          return styles.logoAirlineVS;
        }
        case 'LX': {
          return styles.logoAirlineLX
        }
        case 'SQ': {
          return styles.logoAirlineSQ
        }
        case 'EI': {
          return styles.logoAirlineEI
        }
        case 'WK': {
          return styles.logoAirlineEDW
        }
        case 'AF': {
          return styles.logoAirlineAF
        }
        case 'KL': {
          return styles.logoAirlineKL
        }
        case 'OS': {
          return styles.logoAirlineOS
        }
        case 'EK': {
          return styles.logoAirlineEK
        }
        // new airline
        case 'A3': {
          return styles.logoAirlineA3
        }
        case 'AC': {
          return styles.logoAirlineAC
        }
        case 'AZ': {
          return styles.logoAirlineAZ
        }
        case 'DL': {
          return styles.logoAirlineDL
        }
        case 'LH': {
          return styles.logoAirlineLH
        }
        case 'SN': {
          return styles.logoAirlineSN
        }
        case 'TG': {
          return styles.logoAirlineTG
        }
        case 'TK': {
          return styles.logoAirlineTK
        }
        case 'TP': {
          return styles.logoAirlineTP
        }
        case 'UA': {
          return styles.logoAirlineUA
        }
        case 'UX': {
          return styles.logoAirlineUX
        }
        case '4Y': {
          return styles.logoAirline4Y
        }
        case 'DE': {
          return styles.logoAirlineDE
        }
        default: {
          return null;
        }
      }
    }

    const { multiLang, language, trackingData } = this.props;
    const { completedTrackingStatus, bagsJourney, flightDetails , trackingBookingDetails, deliveryLocation} = trackingData;

    const parameters = {
      '{airline}': flightDetails.marketingAirlineName,
      '{flightNumber}': `${flightDetails.marketingAirlineCode} ${flightDetails.flightNumber}`
    }

    const flight_information = placeholderReplace(multiLang[`bagsHaveCheckedIntoText${language}`], parameters);
    const title =
      multiLang[`${completedTrackingStatus.titleDisplay}${language}`] ?? completedTrackingStatus.titleDisplay;
    const subTitle =
      multiLang[`${completedTrackingStatus.subTitle}${language}`] ?? completedTrackingStatus.subTitle;
    const description =
      multiLang[`${completedTrackingStatus.text}${language}`] ?? completedTrackingStatus.text;
    const warningMessage = multiLang[`${completedTrackingStatus.repatriateBagCount > 1 ? 'Bags' : 'Bag'} to be returned` + language];
    // multiLang[`${completedTrackingStatus.message}${language}`] ?? completedTrackingStatus.message;
    const showWarningMessage = bagsJourney.find(job => job.bagsJourneyStatus === BagsJourneyStatus.UrgentAttention);
    const supportLink = {
      '': 'https://support.airportr.com/hc/en-us/articles/115000581085-My-bags-could-not-be-checked-in-where-do-I-meet-you-to-get-them-back',
      '_fr': 'https://support.airportr.com/hc/fr/articles/115000581085--Mes-bagages-n-ont-pas-pu-%C3%AAtre-enregistr%C3%A9s-o%C3%B9-puis-je-vous-retrouver-pour-les-r%C3%A9cup%C3%A9rer',
      '_de': 'https://support.airportr.com/hc/de/articles/115000581085-Wo-soll-ich-mich-mit-Ihren-Vertretern-treffen-wenn-mein-Gep%C3%A4ck-neu-zugewiesen-wird'
    };

    const showFlightMap = () => {
      const view = <div className={styles.sectionWrapperMap}>
        <FlightMapComponent trackingBookingDetails={trackingBookingDetails} flightDetails={flightDetails} />
      </div>
      return view;
    };

    const showDriverMap = () => {
      const view = <div className={styles.sectionWrapperMap}>
        <DriverMapComponent driverData={null} locationData={deliveryLocation} />
      </div>
      return view;
    };

    return (
      <div className={styles.mainContent}>
        {this.product !== 4 && this.product !== 8
          ? showFlightMap()
          : showDriverMap()
        }

        <div className={styles.sectionWrapper}>
          <div className={styles.section}>
            <div className={styles.card}>
              <div className={styles.cardBody}>
                <h1 className={styles.heading}>{title}</h1>

                <div className={styles.group}>
                  <div>
                    <div className={styles.flexJustifyCenter}>
                      <div className={styles.flightDetails}>
                        <div className={logoClass(flightDetails.marketingAirlineCode)}></div>
                        <p dangerouslySetInnerHTML={{ __html: flight_information }}></p>
                      </div>
                    </div>

                    <h3 className={styles.subHeading}>
                      {subTitle}
                    </h3>
                    {showWarningMessage && warningMessage && <p className={[styles.warning, styles.description, styles.mb_12].join(' ')}>
                      {completedTrackingStatus.repatriateBagCount + ' ' + warningMessage}
                    </p>}
                    <p className={styles.description}>
                      {description}
                    </p>
                    {bagsJourney.find(a => a.bagsJourneyType === BagsJourneyType.Downgraded) && <p className={[styles.description, styles.mt_12].join(' ')}>
                      <a target='_blank' href={supportLink[language]}>{multiLang['How do I collect my bags?' + language]}</a>
                    </p>}

                    {/* ABC */}
                    {this.product === 1 ||
                      this.product === 2 ||
                      this.product === 5 ||
                      this.product === 6 ? (
                      this.state.checkedBags.length >
                        0 ? (
                        <BookingRef.Consumer>
                          {(val) => {
                            return (
                              <BagTagComponent
                                language={language}
                                multiLang={multiLang}
                                bookingRef={val.booking}
                                checkedBags={this.state.checkedBags}
                                repatBags={this.state.repatBags}
                              ></BagTagComponent>
                            );
                          }}
                        </BookingRef.Consumer>
                      ) : null
                    ) : null}
                  </div>

                  <div>
                    <StatusList
                      bagsJourney={bagsJourney}
                      multiLang={multiLang}
                      language={language}
                      completedTrackingStatus={completedTrackingStatus}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CompleteStatusComponent;



// WEBPACK FOOTER //
// ./src/containers/complete/complete-status.component.tsx